import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Button } from '@mui/material';
import { ReactNode } from 'react';
import { toast } from 'react-toastify';

interface CopyToClipboardProps {
  label?: ReactNode;
  content: string;
  disabled?: boolean;
}
const CopyToClipboard = ({ label = '', content, disabled = false }: CopyToClipboardProps) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(content).then(
      () => {
        // Text successfully copied to clipboard
        toast.success('Copied to clipboard!');
      },
      (err) => {
        // Unable to copy to clipboard
        // eslint-disable-next-line no-console
        console.error('Could not copy text: ', err);
        toast.error('Could not copy text to clipboard', {
          autoClose: false,
          hideProgressBar: true,
        });
      },
    );
  };

  return (
    <Button variant="text" onClick={handleCopy} disabled={disabled}>
      {label}
      <ContentCopyIcon fontSize="small" />
    </Button>
  );
};

export default CopyToClipboard;
